/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */

export const LOGIN_PATH = "/login";

const MAX_ENTRIES = 2; // current page + one previous page

let stack = [];

export function locationKey(location) {
  return `${location.pathname}${location.search || ""}${location.hash || ""}`;
}

export function resetAppHistory(pathKey = LOGIN_PATH) {
  stack = pathKey ? [pathKey] : [];
}

export function isStorefrontPath(pathname) {
  if (!pathname) return false;
  if (pathname.startsWith("/store/") || pathname === "/test-design") return true;

  const hostname = window.location.hostname;
  const isMainDomain =
    hostname === "madar.iq" ||
    hostname === "www.madar.iq" ||
    hostname === "localhost" ||
    hostname === "127.0.0.1";

  return !isMainDomain && (pathname === "/" || pathname.startsWith("/store/"));
}

export function shouldLimitBack(pathname) {
  return !isStorefrontPath(pathname);
}

export function applyLimitedBack(location, navType, navigate) {
  const key = locationKey(location);

  if (navType === "POP") {
    if (stack.length === 0) {
      stack = [key];
      return;
    }
    const idx = stack.lastIndexOf(key);
    if (idx === -1) {
      const safe = stack[stack.length - 1];
      if (safe && safe !== key) {
        navigate(safe, { replace: true });
      }
      return;
    }
    stack = stack.slice(0, idx + 1);
    return;
  }

  if (navType === "REPLACE") {
    if (stack.length === 0) stack = [key];
    else stack[stack.length - 1] = key;
    if (stack.length > MAX_ENTRIES) stack = stack.slice(-MAX_ENTRIES);
    return;
  }

  if (stack[stack.length - 1] === key) return;
  stack = [...stack, key].slice(-MAX_ENTRIES);
}

export function replaceAndLock(navigate, path) {
  const dest = path || LOGIN_PATH;
  resetAppHistory(dest);
  navigate(dest, { replace: true });
}

export function goToLoginScreen(navigate) {
  replaceAndLock(navigate, LOGIN_PATH);
}
